/** Source: docs/structure/04_詳細設計_ページ内容スキーマ.md §3. */
import type { ContentBlock } from '../../lib/contentTypes'
import { Always } from './Always'
import { Article } from './Article'
import { Buddy } from './Buddy'
import { Butlers } from './Butlers'
import { Cards } from './Cards'
import { Caution } from './Caution'
import { Chapter } from './Chapter'
import { Collection } from './Collection'
import { Columns } from './Columns'
import { Company } from './Company'
import { DefBand } from './DefBand'
import { Faq } from './Faq'
import { Flow } from './Flow'
import { Form } from './Form'
import { GalleryBuy } from './GalleryBuy'
import { Goods } from './Goods'
import { IncludeExclude } from './IncludeExclude'
import { Legal } from './Legal'
import { Plans } from './Plans'
import { PriceTable } from './PriceTable'
import { RelatedSites } from './RelatedSites'
import { Services } from './Services'
import { Spec } from './Spec'
import { Split } from './Split'

export { Cta } from './Cta'

export function BlockRenderer({ block }: { block: ContentBlock }) {
  switch (block.type) {
    case 'chapter': return <Chapter {...block} />
    case 'def-band': return <DefBand {...block} />
    case 'split': return <Split {...block} />
    case 'cards': return <Cards {...block} />
    case 'price-table': return <PriceTable {...block} />
    case 'plans': return <Plans {...block} />
    case 'flow': return <Flow {...block} />
    case 'faq': return <Faq {...block} />
    case 'caution': return <Caution {...block} />
    case 'buddy': return <Buddy {...block} />
    case 'always': return <Always {...block} />
    case 'butlers': return <Butlers {...block} />
    case 'services': return <Services {...block} />
    case 'collection': return <Collection {...block} />
    case 'columns': return <Columns {...block} />
    case 'goods': return <Goods {...block} />
    case 'spec': return <Spec {...block} />
    case 'include-exclude': return <IncludeExclude {...block} />
    case 'article': return <Article {...block} />
    case 'gallery-buy': return <GalleryBuy {...block} />
    case 'form': return <Form {...block} />
    case 'legal': return <Legal {...block} />
    case 'company': return <Company {...block} />
    case 'related-sites': return <RelatedSites {...block} />
  }
}
